<!-- =========================================================================================
    File Name: MailItem.vue
    Description: Mail Item - Displays mail item
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="custom-item" :class="{ 'mail__opened-mail': false, 'important': isImportant }">
    <div class="w-full" :class="{ '': isDesktop }" style="display: flow-root;">
      <div class="items-header listview">
        <div class="item-details mt-2 mb-1">
          <div class="ml-0" :class="{ 'important': isImportant }">
            
            <!-- <span class="mr-1">{{ formatDate(data.dt_report, {timeStyle: "medium"}) }}</span>  -->
            
                <template v-if="!isAuthenticated">
                  <span class="mr-1 date-float" v-if="!isReport && canDisplayDateField">{{ formatDate(data.dt_publish, { dateStyle: "short" }) }}</span>
                  <span class="mr-1 date-float" v-if="isReport && canDisplayDateField">{{ formatFullDate(data.dt_report, { dateStyle: "short" }) }}</span>
                  <!-- <span class="mr-1 date-float" v-if="isItemNews">{{ data.dt_publish | moment("from") }}</span> -->
                </template>
                <template v-else>
                  <span class="mr-1 date-float" v-if="!isReport && canDisplayDateField && !schedule">{{ formatDate(data.dt_publish, { dateStyle: "short" }) }}</span>
                  <span class="mr-1 date-float" v-if="isReport && canDisplayDateField && !schedule">{{ formatFullDate(data.dt_report, { dateStyle: "short" }) }}</span>
                  <span class="mr-1 date-float" v-if="schedule">{{ formatFullDate(data.eventScheduleDuration_dateTo, { dateStyle: "short" }) }}</span>
                  <!-- <span class="mr-1 date-float" v-if="isItemNews">{{ data.data_object | moment("from") }}</span> -->
                </template>

            <div class="mt-1 important-list">

                  <span class="important-list-chip mr-1" v-if="isImportant && !data.inLive"></span>
                <div class="badge live liv-list" v-if="data.inLive">
                  <div class="badge-wrap">
                    <span class="badge-icon">
                      <svg height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7 2.333c2.577 0 4.667 2.09 4.667 4.667S9.577 11.667 7 11.667 2.333 9.577 2.333 7 4.423 2.333 7 2.333zm0 1.05c-1.997 0-3.617 1.62-3.617 3.617 0 1.997 1.62 3.617 3.617 3.617 1.997 0 3.617-1.62 3.617-3.617 0-1.997-1.62-3.617-3.617-3.617z">
                        </path>
                      </svg><span class="badge-icon-inner"><svg aria-hidden="true" focusable="false" viewbox="0 0 14 14">
                          <path
                            d="M7 9.567c1.418 0 2.567-1.15 2.567-2.567 0-1.418-1.15-2.567-2.567-2.567-1.418 0-2.567 1.15-2.567 2.567 0 1.418 1.15 2.567 2.567 2.567z">
                          </path>
                        </svg>
                      </span>
                    </span>
                    <span class="badge-text">{{ $t('BADGES').InLive }}</span>
                  </div>
                </div>
              </div>  
                    <span class="mr-1 bold chapeu etq">{{ chapeu }}</span>
                    
                  </div>
                  <!-- <div class="date date-right" v-if="fromAuthorDetail">
                <template v-if="!isAuthenticated">
                  <span class="mr-1" v-if="!isItemNews">{{ formatDate(data.dt_publish, { dateStyle: "short" }) }}</span>
                  <span class="mr-1" v-if="isItemNews">{{ data.dt_publish | moment("from") }}</span>
                </template>
                <template v-else>
                  <span class="mr-1" v-if="!isItemNews">{{ formatDate(data.dt_report, { dateStyle: "short" }) }}</span>
                  <span class="mr-1" v-if="isItemNews">{{ data.data_object | moment("from") }}</span>
                </template> -->

                  </div>
            </div>
           
              <div class="content-list pl-3 pr-3">
                <span>{{ getTitle }} — {{ $t('VIEW_MODES').In }} <span class="link cursor-pointer" @click.stop="navigateToSubject"> {{ getSubjectName(data.subjects) }} </span> — </span>
                <span class="cursor-pointer link" @click.stop="$emit('open-author', data.author)" v-if="!fromAuthorDetail"> <span v-if="canDisplayDateField"></span> {{ data.author.nickname? data.author.nickname : data.author.name }}</span>
                <span><action-icons-field
                    :data="data" 
                    :isAuthenticated="isAuthenticated" 
                    :isDesktop="isDesktop"
                    :canDisplayAddPlaylist="false"
                    :canDisplayMultimedia="false"
                    :canDisplaySpeechText="false"
                    :canDisplayDownloadFile="false"
                    :canDisplaySave="canDisplaySave"
                    :canDisplayRemove="canDisplayRemove"
                    @addPlaylist="addPlaylist"
                    @playMultimedia="playMultimedia"
                    @onDownloadFile="onDownloadDocument"
                    @open-exclusive-content="$emit('open-exclusive-content')"
                    @remove-news="$emit('remove-news', data)"
                    @save-schedule-news="$emit('save-schedule-news', data)">
                  </action-icons-field></span>
              </div>
            <!-- <div class="flex float-right" v-if="!data.displayDetail">
              <vx-tooltip text="Conteúdo exclusivo" delay=".1s"><span class="iconsafra"><feather-icon
                    @click.stop="$emit('open-exclusive-content')" icon="LockIcon" class="mr-0"
                    :svgClasses="['icon-Volume h-5 w-5']" /></span></vx-tooltip>
            </div> -->
    </div>
  </div>
</template>

<script>
import DropdownUserInfo from "../widgets/dropdown-user-info/DropdownUserInfo.vue";
import AppConstants from "../../../appConstants";
import { CONTENT } from "../../../enums/enum-content";
import convertDatetimeHelper from '../../../helpers/convert-datetime-helper';
import GeneralHelper from '../../../helpers/general-helper';
import VxTooltip from '../../../layouts/components/vx-tooltip/VxTooltip.vue';
import translateFieldHelper from '../../../helpers/translate-field-helper';
import InformativePreviewData from './InformativePreviewData.vue';
import generalHelper from '../../../helpers/general-helper';
import ActionIconsField from '../../../layouts/components/customizer/ActionIconsField.vue';
import { EventBus } from '../../../event-bus';


export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    isDesktop: {
      type: Boolean,
      required: true
    },
    contentId: {
      require: true
    },
    currentCommodity: {
      require: true
    },
    isAuthenticated: {
      require: true
    },
    fromAuthorDetail: {
      type: Boolean,
      default: false
    },
    canDisplaySave: {
      type: Boolean,
      default: true
    },
    schedule: {
      type: Boolean,
      default: false
    },
    canDisplayRemove: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      publisherVisible: false,
      thumbPath: '',
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.5
      },
    };
  },
  async created() {
    await this.getThumbPath();
  },
  watch: {},
  computed: {
    canDisplayDateField() {
      return (
        this.data.newsContent.findIndex(
          item =>
            item.code != CONTENT.CONSULTING_COURSES
        ) >= 0
      );
    },
    isReport() {
      return (
        this.data.newsContent.findIndex(
          item =>
            item.code == CONTENT.INFORMATIVE ||
            item.code == CONTENT.EXPORTS ||
            item.code == CONTENT.STATISTIC
        ) >= 0
      );
    },
    getTitle() {
      if (!this.data) return '';
      if (this.data.newsContent[0].code == CONTENT.STATISTIC ||
        this.data.newsContent[0].code == CONTENT.EXPORTS ||
        this.data.newsContent[0].code == CONTENT.INFORMATIVE) {
        return translateFieldHelper.getTranslateField('name', this.data.reportType);
      }
      return this.data.content.title.data;
    },
    AppActiveUser() {
      return this.$store.state.AppActiveUser;
    },
    displayPadlock() {
      return this.AppActiveUser.profile == AppConstants.USER_PROFILE.FREE;
    },
    isListView() {
      return (
        this.$store.state.reportViewStyle ===
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW
      );
    },
    soundCloudLink() {
      return `${AppConstants.URL_SOUNDCLOUD_EMBED}${this.data.soundcloud}&show_teaser=false`;
    },
    audioLink() {
      return this.data.audio.image_path;
    },
    audioType() {
      if (this.data.audio) {
        return `audio/${this.data.audio.extension}`;
      }
      return "";
    },
    badgeContentTypeIconClass() {
      const c = "h-3 w-3";
      if (this.data.document) return `${c} badge-content-blue`;
      if (this.data.audio || this.data.soundcloud)
        return `${c} badge-content-purple`;
      if (this.data.youtubeId) return `${c} badge-content-red`;
      return c;
    },
    youtubeLink() {
      return `${AppConstants.URL_YOUTUBE_EMBED}${this.data.youtubeId
        }?iv_load_policy=3&modestbranding=0&playsinline=1&showinfo=0&rel=0&enablejsapi=1`;
    },
    badgeTypeClass() {
      if (this.data.document) return "attach-document";
      if (this.data.audio) return "audio";
      if (this.data.youtubeId) return "video";
      if (this.data.soundcloud) return "podcast";
      if (this.data.spotify) return "podcast";
      return "";
    },
    badgeContentType() {
      if (this.data.document) return "Anexo";
      if (this.data.audio) return "Audio";
      if (this.data.youtubeId) return "Video";
      if (this.data.soundcloud) return "Podcast";
      return "";
    },
    badgeContentTypeIcon() {
      if (this.data.document) return "PaperclipIcon";
      if (this.data.audio) return "VoicemailIcon";
      if (this.data.youtubeId) return "PlayIcon";
      if (this.data.soundcloud) return "MicIcon";
      return "";
    },
    hatName() {
      if (this.data.hat[0]) {
        return this.data.hat[0].name.toUpperCase();
      }
      return this.data.newsContent[0][`name${this.$i18n.locale}`];
    },
    canDisplayPreview() {
      return (
        this.isDesktop &&
        (this.data.newsContent[0].code == CONTENT.NEWS ||
          this.data.newsContent[0].code == CONTENT.CONSULTING ||
          this.data.newsContent[0].code == CONTENT.STATISTIC ||
          this.data.newsContent[0].code == CONTENT.EXPORTS ||
          this.data.newsContent[0].code == CONTENT.CONSULTING_SAFRAS_TV ||
          this.data.newsContent[0].code == CONTENT.CONSULTING_COURSES ||
          this.data.newsContent[0].code == CONTENT.CONSULTING_SPEECHES ||
          this.data.newsContent[0].code == CONTENT.CONSULTING_EXCHANGE ||
          this.data.newsContent[0].code == CONTENT.WEATHER)
      );
    },
    canAddPlaylist() {
      return (
        this.hasYoutube ||
        this.hasAudio ||
        this.hasSpotify ||
        this.hasSoundCloud
      ) && this.isAuthenticated;
    },
    hasMultimedia() {
      return (
        this.hasAudio ||
        this.hasYoutube ||
        this.hasSoundCloud ||
        this.hasSpotify
      );
    },
    isItemNews() {
      return this.contentId == CONTENT.NEWS;
    },
    chapeu() {
      if (this.data && this.data.hat[0] && this.data.hat[0].name) {
        return this.data.hat[0].name.toUpperCase();
      }
      return "";
    },
    hasDocument() {
      return !!this.data.document;
    },
    hasAudio() {
      return !!this.data.audio;
    },
    hasYoutube() {
      return !!this.data.youtubeId;
    },
    hasSpotify() {
      return !!this.data.spotify;
    },
    hasSoundCloud() {
      return !!this.data.soundcloud;
    },
    hasImageUrl() {
      return !!this.data.image;
    },
    isImportant() {
      return this.data.importance > 0;
    },
    isDisclosureAnnouncement() {
      return this.data.disclosureType == AppConstants.DISCLOSURE_TYPE_ENUM.ANNOUNCEMENT;
    },
    isDisclosureInvite() {
      return this.data.disclosureType == AppConstants.DISCLOSURE_TYPE_ENUM.INVITE;
    },
    featherIconSize() {
      if (this.isDesktop) {
        return "h-4 w-4";
      } else {
        return "h-6 w-6";
      }
    },
    getIcon() {
      if (this.hasYoutube) {
        return "VideoIcon";
      } else if (this.hasAudio || this.hasSoundCloud) {
        return "MicIcon";
      } else if (this.hasImageUrl) {
        return "PaperclipIcon";
      } else {
        return null;
      }
    },
    hasTextToSpeech() {
      if ( (this.data.content.abstract || this.data.content.text) && !this.hasDocument && this.isDesktop ) {
        return `${this.getTitle} ${this.data.content.abstract.data
          } ${this.data.content.text.data}`;
      }
      return false;
    },
    canSpeechText() {
      return generalHelper.canSpeechText(this.data, this.isDesktop);
    },
  },
  methods: {
    getIconCard() {
      if (this.hasYoutube) {
        return "VideoIcon";
      } else if (
        this.hasAudio ||
        this.hasSoundCloud ||
        this.hasSpotify
      ) {
        return "MicIcon";
      } else if (this.hasDocument) {
        return "PaperclipIcon";
      } else {
        return null;
      }
    },
    onDownloadDocument(data) {
      this.$emit("onDownloadFile", data);
    },
    async getThumbPath() {
      // this.thumbPath = require("@/assets/images/informative/placeholder115.svg");
      if (this.data && this.data.thumb) {
        const exist = await GeneralHelper.checkImageExist(this.data.thumb.image_path);
        if (exist) {
          this.thumbPath = this.data.thumb.image_path;
        }
      }
    },
    formatFullDate(val, obj) {
      return convertDatetimeHelper.formatFullDate(val, obj);
    },
    formatDate(val, obj) {
      return convertDatetimeHelper.formatDate(val, obj);
    },
    openDetail() {
      console.log('[openDetail]', this.data);
      this.$emit("openDetail", this.data);
    },
    navigateToSubject() {
      const subject = translateFieldHelper.getSubjectData(this.data.subjects, this.currentCommodity);
      EventBus.$emit(AppConstants.BUS_EVENT_NAVIGATE_SUBJECT, subject.code);
    },
    getSubjectName(subjects) {
      return translateFieldHelper.getSubjectName(subjects, this.currentCommodity);
    },
    getSubjectIcon(subjects) {
      if (this.currentCommodity.id) {
        const sub = subjects.find(
          item => item.code == this.currentCommodity.id
        );
        if (sub) {
          return sub.icon;
        }
      }
      return subjects[0].icon;
    },
    addPlaylist() {
      this.$store.dispatch("insertItemPlaylist", this.data);
    },
    isReportDateToday() {
      return this.data.data_object.getUTCDate() == new Date().getUTCDate();
    },
    playMultimedia({data, isTextSpeech}) {
      this.$emit("playMultimedia", {
        data: data,
        isTextSpeech: isTextSpeech
      });
      // EventBus.$emit(AppConstants.BUS_EVENT_OPEN_PLAYLIST, true);

    }
  },
  components: {
    DropdownUserInfo,
    VxTooltip,
    InformativePreviewData,
    ActionIconsField
  }
};
</script>

<style lang="scss" scoped>
.item-commodity-icon {
  margin-right: 15px;
}

.custom-item {
  padding-top: 5px;
  padding-bottom: 5px;
  background-color: #ffffff;
  border-radius: 6px;
  width: 100%;
}

.theme-dark .custom-item {
  background-color: #353e45;
}

.custom-item .card-img {
  width: 100%;

  background-position-x: 10px;
  background-repeat: no-repeat;
}

.custom-item:hover {
  transform: none !important;
}

.item-commodity {
  text-transform: none !important;
  font-weight: 600;
  color: #2c2c2c;
}


.item-avatar {
  margin-top: -6px;
  float: left;
}

.item-right {
  height: 60px;
}

.item-date {
  margin-bottom: 25px;
  
}

.chips {
  margin-top: 10px;
  margin-bottom: 10px;
}

.exact-fit {
  word-wrap: break-word;
  width: 400px;
}

.item-date-report {
  right: 10px;
  position: absolute;
  margin-top: -5px;
}

.item-atualizado {
  position: relative;
  top: 55px;
  margin-right: -5px;
}

.play-icon-chip {
  margin-top: -13px;
}

.badge {
  display: inline-block;
  padding: 2px 6px;
  color: #fff;
  background: #e41505;
  border-radius: 4px;
  float: right;
  margin-top: 5px;
  margin-right: 5px;
  height: 18px;
  width: max-content !important;
}

.live {
  min-width: 70px;
}

.badge-wrap {
  display: flex;
  align-items: center;
}

.badge-icon {
  position: relative;
  display: inline-flex;
  margin-right: 2px;
}

.badge-icon-inner {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  will-change: opacity;
  -webkit-animation: ani-breath 1.8s ease infinite;
  animation: ani-breath 1.8s ease infinite;
}

.badge-icon svg {
  fill: currentColor;
}

.badge-text {
  display: inline-flex;
  font-size: 10px;
  line-height: 14px;
  text-transform: uppercase;
}

.badge {
  display: inline-block;
  padding: 2px 6px;
  color: #fff;
  background: #e41505;
  border-radius: 4px;
  float: right;
  margin-top: 5px;
  margin-right: 5px;
  height: 18px;
  width: max-content !important;
}

.badge-wrap {
  display: flex;
  align-items: center;
}

.badge-icon {
  position: relative;
  display: inline-flex;
  margin-right: 2px;
}

.badge-icon-inner {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  will-change: opacity;
  -webkit-animation: ani-breath 1.8s ease infinite;
  animation: ani-breath 1.8s ease infinite;
}

.badge-icon svg {
  fill: currentColor;
}

.badge-text {
  display: inline-flex;
  font-size: 10px;
  line-height: 14px;
  text-transform: uppercase;
}

@-webkit-keyframes ani-breath {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
}

@keyframes ani-breath {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
}

.live-view {
  background-color: #e41505;
  border: 1px solid #910f05;
  display: inline-table;
  color: #FFF;
  border-radius: 5px;
  padding-left: 25px !important;
  padding: 2px 5px;
  font-size: 13px;
  line-height: 18px;
}


.badge.float-left {
  margin-top: 1px;
}</style>
